<!--
  参考：https://blog.csdn.net/caomage/article/details/85006973
-->
<template>
  <transition name="el-fade-in">
    <div class="page-up" @click="scrollToTop" v-show="toTopShow">
      <i class="el-icon-caret-top"></i>
    </div>
  </transition>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      toTopShow: false,
    };
  },
  mounted() {
    this.$nextTick(function () {
      window.addEventListener("scroll", this.handleScroll, true);
    });
  },
  methods: {
    handleScroll() {
      let dom = document.body;
      this.scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      if (this.scrollTop > 300) {
        this.toTopShow = true;
      } else {
        this.toTopShow = false;
      }
    },
    scrollToTop() {
      let timer = null;
      let _this = this;
      let containerScroll = 0;
      timer = setInterval(function () {
        containerScroll =
          document.documentElement.scrollTop ||
          window.pageYOffset ||
          document.body.scrollTop;
        containerScroll = containerScroll - 100;
        if (containerScroll < 0) {
          clearInterval(timer);
        }
        document.documentElement.scrollTop = containerScroll;
        // window.pageYOffset = containerScroll
        document.body.scrollTop = containerScroll;
      }, 10);
    },
  },
  destroyed() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
};
</script>

<style scoped>
.page-up {
  background-color: #2e81e1;
  position: fixed;
  right: 50px;
  bottom: 30px;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  cursor: pointer;
  transition: 0.3s;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.5);
  opacity: 0.5;
  z-index: 100;
}

.el-icon-caret-top {
  color: #fff;
  display: block;
  line-height: 40px;
  text-align: center;
  font-size: 18px;
}

p {
  display: none;
  text-align: center;
  color: #fff;
}

.page-up:hover {
  opacity: 1;
  background: #2e81e1;
}
</style>



// WEBPACK FOOTER //
// src/components/backTop/index.vue